<template>
  <div class="user">
    <self-title :title="titles" :fixed="true" @titleClick="titleClick"></self-title>
    <transition name="slide-fade">
      <div v-permissions="'case:query'" class="main-page" v-show="web == 'main'">
        <div class="title">案件中心</div>
        <el-form
          class="search-form"
          ref="searchForm"
          :model="searchForm"
          label-width="100px"
          @submit.native.prevent="false"
        >
          <el-row>
            <el-col :xs="12" :sm="6">
              <el-form-item label="业务类型" class="roleName">
                <el-select
                  v-model="searchForm.businessType"
                  size="small"
                  placeholder="请选择"
                  clearable
                  @change="search(1)"
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option :label="item.name" :value="item.name" v-for="item in businessTypes" :key="item.name">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="12" :sm="6">
              <el-form-item label="公司名称" class="roleName">
                <!-- <el-select
                  v-model="searchForm.companyName"
                  placeholder="请选择"
                  size="small"
                  filterable
                  clearable
                  @change="search(1)"
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option :label="item" :value="item" v-for="(item, index) in companys" :key="'2-' + index">
                  </el-option>
                </el-select> -->
                <el-input
                  v-model="searchForm.companyName"
                  name="companyName"
                  size="small"
                  placeholder="请输入公司名称"
                  clearable
                  @keyup.enter.native="search(1)"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="12" :sm="6">
              <el-form-item class="show-pc roleName" label="区域">
                <el-cascader
                  class="width-100"
                  v-model="searchForm.qy"
                  placeholder="请选择区域"
                  :options="options"
                  :props="{ checkStrictly: true }"
                  filterable
                  clearable
                  size="small"
                  @change="searchQyChange"
                >
                </el-cascader>
              </el-form-item>
              <el-form-item class="show-phone roleName" label="区域">
                <el-row>
                  <el-col :span="8"
                    ><div @click="popup1ShowState = true">
                      <el-input v-model="searchForm.area1" size="small" :disabled="true"></el-input>
                    </div>
                  </el-col>
                  <el-col :span="8"
                    ><div @click="popup2ShowState = true">
                      <el-input v-model="searchForm.area2" size="small" :disabled="true"></el-input>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div @click="popup3ShowState = true">
                      <el-input v-model="searchForm.area3" size="small" :disabled="true"></el-input>
                    </div>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :xs="12" :sm="6">
              <el-form-item label="状态" class="roleName">
                <el-select v-model="searchForm.state" size="small" placeholder="请选择" @change="search(1)">
                  <el-option :label="item.name" :value="item.name" v-for="(item, index) in states" :key="index">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="12" :sm="6">
              <el-form-item label="案件经理" prop="customerManagerId">
                <el-select
                  v-model="searchForm.customerManagerId"
                  size="small"
                  placeholder="请选择"
                  clearable
                  @change="search(1)"
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option :label="item.name" :value="item.id" v-for="(item, index) in persons" :key="'7-' + index">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="12" :sm="8">
              <el-form-item label="负责人" class="roleName">
                <el-select
                  class="width-100"
                  ref="selectMultiple"
                  v-model="searchForm.caseAccountants"
                  multiple
                  placeholder="请选择"
                  size="small"
                  :disabled="userInfo.content_jurisdiction == '0'"
                  @change="accountantSearchChange"
                >
                  <el-option-group
                    :disabled="
                      searchForm.caseAccountants &&
                        searchForm.caseAccountants.length > 0 &&
                        searchForm.caseAccountants.indexOf('no') < 0
                    "
                  >
                    <el-option label="未分配" value="no"></el-option>
                  </el-option-group>
                  <el-option-group
                    :disabled="
                      searchForm.caseAccountants &&
                        searchForm.caseAccountants.length > 0 &&
                        searchForm.caseAccountants.indexOf('no') >= 0
                    "
                  >
                    <el-option
                      v-show="
                        (userInfo.content_jurisdiction == '0' && userInfo.id === item.id) ||
                          userInfo.content_jurisdiction != '0'
                      "
                      :label="item.name"
                      :value="item.id"
                      v-for="(item, index) in persons"
                      :key="'8-' + index"
                    >
                    </el-option>
                  </el-option-group>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col class="show-pc" :xs="24" :sm="10">
              <el-form-item label="截止时间" class="deadline">
                <!-- <el-select
                  v-model="searchForm.deadlineDays"
                  size="small"
                  placeholder="请选择"
                  clearable
                  @change="search(1)"
                >
                  <el-option label="不限" value=""></el-option>
                  <el-option :label="item.roleName" :value="item.roleId" v-for="(item, index) in times" :key="index">
                  </el-option>
                </el-select> -->
                <el-date-picker
                  size="small"
                  v-model="searchForm.deadline"
                  type="daterange"
                  range-separator="至"
                  value-format="yyyy-MM-dd 00:00:00"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="deadlineChange"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24">
              <el-form-item class="btn" label-width="10px">
                <el-button
                  v-permissions="'case:query'"
                  type="primary"
                  size="small"
                  class="search"
                  icon="el-icon-search"
                  @click="search(1)"
                  >查询
                </el-button>
                <el-button
                  v-permissions="'customer:query'"
                  type="warning"
                  plain
                  size="small"
                  class="search"
                  @click="reset"
                  >清空筛选项
                </el-button>
                <el-button
                  v-permissions="'case:add'"
                  type="primary"
                  size="small"
                  class="add"
                  icon="el-icon-plus"
                  @click="add"
                  >新增案件</el-button
                >
                <button class="show-pc-inline import-btn el-button el-button--warning el-button--small">
                  <i class="el-icon-upload"></i>
                  导入案件
                  <input type="file" class="import-excel" name="picJdcmp" ref="picJdcmp" @change="fileRead" />
                </button>
                <el-button
                  v-permissions="'case:exportExcel'"
                  type="success"
                  size="small"
                  class="show-pc-inline reset"
                  icon="el-icon-download"
                  @click="exportCase"
                  >导出案件
                </el-button>
                <el-button
                  type="text"
                  size="small"
                  class="show-pc-inline search"
                  icon="el-icon-download"
                  @click="downloadExcel"
                  >导入案件模板下载
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="show-pc">
          <el-table :data="tableData" height="61vh" style="width: 100%" @cell-click="cellClick">
            <el-table-column label="业务类型">
              <template slot-scope="scope">
                <span>{{ scope.row.aosCase.businessType }}</span>
              </template>
            </el-table-column>
            <el-table-column label="公司名称">
              <template slot-scope="scope">
                <span>{{ scope.row.aosCase.companyName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="区域">
              <template slot-scope="scope">
                <span>{{ scope.row.aosCase.area1 }}/{{ scope.row.aosCase.area2 }}/{{ scope.row.aosCase.area3 }}</span>
              </template>
            </el-table-column>
            <el-table-column label="法人">
              <template slot-scope="scope">
                <span>{{ scope.row.aosCase.legalPerson }}</span>
              </template>
            </el-table-column>
            <el-table-column label="纳税性质">
              <template slot-scope="scope">
                <span>{{ scope.row.aosCase.taxNature }}</span>
              </template>
            </el-table-column>
            <el-table-column label="案件经理">
              <template slot-scope="scope">
                <span>{{ scope.row.aosCase.customerManagerName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="负责人">
              <template slot-scope="scope">
                <span v-for="(item, index) in scope.row.caseAccountantList" :key="index">
                  <el-tag size="small">{{ item.name }}</el-tag
                  >&nbsp;
                </span>
              </template>
            </el-table-column>
            <el-table-column label="截止日期">
              <template slot-scope="scope">
                <span :class="[compareTime(scope.row.aosCase.deadline) ? 'text-danger' : 'text-success']">{{
                  scope.row.aosCase.deadline && scope.row.aosCase.deadline.substring(0, 10)
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="210px">
              <template slot-scope="scope">
                <el-button
                  v-permissions="'case:update'"
                  size="small"
                  type="primary"
                  plain
                  @click="handleEdit(scope.$index, scope.row.aosCase)"
                  >编辑</el-button
                >
                <el-button
                  v-permissions="'case:shareCase'"
                  size="small"
                  plain
                  type="warning"
                  @click="shareCase(scope.row.aosCase)"
                  >分享</el-button
                >
                <el-button
                  v-permissions="'case:delete'"
                  size="small"
                  plain
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row.aosCase)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页器 -->
          <div class="page">
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="searchForm.currentPage"
              :page-sizes="[100, 200, 500, 1000, 2000]"
              :page-size="searchForm.pageSize"
              layout="total, prev, pager, next, sizes, jumper"
              :total="searchForm.total"
            >
            </el-pagination>
          </div>
        </div>
        <div class="show-phone">
          <el-table :data="tableData" height="63vh" style="width: 100%" @cell-click="cellClick">
            <el-table-column label="公司名称">
              <template slot-scope="scope">
                <span>{{ scope.row.aosCase.companyName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="案件经理">
              <template slot-scope="scope">
                <span>{{ scope.row.aosCase.customerManagerName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100px">
              <template slot-scope="scope">
                <el-button size="small" type="primary" plain @click="handleEdit(scope.$index, scope.row.aosCase)"
                  >编辑</el-button
                >
                <p style="height: 5px"></p>
                <el-button
                  v-permissions="'case:shareCase'"
                  size="small"
                  plain
                  type="warning"
                  @click="shareCase(scope.row.aosCase)"
                  >分享</el-button
                >
                <p v-permissions="'case:shareCase'" style="height: 5px"></p>
                <el-button
                  v-permissions="'case:delete'"
                  size="small"
                  plain
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row.aosCase)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页器 -->
          <div class="page">
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="searchForm.currentPage"
              :page-size="searchForm.pageSize"
              layout="total, prev, pager, next"
              :total="searchForm.total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </transition>
    <!-- <transition name="slide-fade">
      <self-detail
        ref="detail"
        v-if="web == 'edit' || web == 'add' || web == 'detail'"
        :case-id="addForm.id"
        :detail-data="addForm"
        :web-state="web"
        :detail-persons="persons"
        @cancel="cancel"
        @save="save"
      ></self-detail>
    </transition> -->
    <van-popup v-model="popup1ShowState" position="bottom" :style="{ height: '50%' }" :lazy-render="false">
      <van-picker
        ref="pickerQy"
        show-toolbar
        title="省"
        :columns="options1"
        @confirm="pickerConfirm1"
        @cancel="pickerCancel1"
      />
    </van-popup>
    <van-popup v-model="popup2ShowState" position="bottom" :style="{ height: '50%' }" :lazy-render="false">
      <van-picker
        ref="pickerQy"
        show-toolbar
        title="市"
        :columns="options2"
        @confirm="pickerConfirm2"
        @cancel="pickerCancel2"
      />
    </van-popup>
    <van-popup v-model="popup3ShowState" position="bottom" :style="{ height: '50%' }" :lazy-render="false">
      <van-picker
        ref="pickerQy"
        show-toolbar
        title="县/区"
        :columns="options3"
        @confirm="pickerConfirm3"
        @cancel="pickerCancel3"
      />
    </van-popup>
    <input id="rsg-link" style="opacity: 0;position: absolute; top: -9999px; right: -9999px" readonly />
  </div>
</template>

<script>
import cityData from '../../utils/Data'
// import SelfDetail from './components/Detail'
export default {
  name: 'Case',
  components: {
    // SelfDetail
  },
  data() {
    return {
      userInfo: {},
      titles: ['案件中心'],
      web: 'main',
      searchForm: {
        qy: [],
        area1: '',
        area2: '',
        area3: '',
        businessType: '',
        companyName: '',
        state: '在办',
        caseAccountants: [],
        jzsj: '',
        deadlineDays: '',
        deadline: [],
        deadlineA: '',
        deadlineB: '',
        currentPage: 1,
        pageSize: 100,
        total: 0,
        accountantsSearch: []
      },
      addForm: {
        companyName: '', // 公司名称
        businessType: '', // 业务类型
        taxNature: '', // 纳税性质
        registeredCapital: '', // 注册资金
        legalPerson: '', // 法人
        legalPersonIdcardEmblem: '', // 法人身份证国徽面
        legalPersonIdcardHead: '', // 法人身份证头像面
        supervisor: '', // 监事
        supervisorIdcardEmblem: '', // 监事身份证国徽面
        supervisorIdcardHead: '', // 监事身份证头像面
        treasurer: '', // 财务负责人
        treasurerIdcardEmblem: '', // 会计身份证国徽面
        treasurerIdcardHead: '', // 会计身份证头像面
        natureOfBusiness: '', // 经营范围
        isBookkeeping: '', // 是否代账
        customerManagerId: '', // 客户经理
        customerManagerName: '', // 客户经理
        caseAccountant: [], // 负责人
        advancePayment: '', // 预付款
        caseType: '', // 案件类型
        state: '', // 状态
        finalPayment: '', // 尾款
        remark: '', // 备注
        picJdcmp: '',
        picJdcmp2: '',
        caseChange: [],
        qy: '', // 区域
        qy2: '', // 区域
        address: '',
        deadline: '' // 截止日期
      },
      roles: [],
      businessTypes: [
        { roleId: '注册', roleName: '注册' },
        { roleId: '变更注销', roleName: '变更注销' },
        { roleId: '资质代办', roleName: '资质代办' },
        { roleId: '代理记账', roleName: '代理记账' }
      ],
      taxs: [
        { roleId: '小规模', roleName: '小规模' },
        { roleId: '一般纳税人', roleName: '一般纳税人' }
      ],
      states: [
        { roleId: '在办', roleName: '在办' },
        { roleId: '办结', roleName: '办结' }
      ],
      persons: [],
      cycle: [
        { roleId: '1', roleName: '30天内到期' },
        { roleId: '2', roleName: '60天内到期' },
        { roleId: '3', roleName: '90天内到期' }
      ],
      times: [
        { roleId: 10, roleName: '10天' },
        { roleId: 20, roleName: '20天' },
        { roleId: 30, roleName: '30天' }
      ],
      companys: [],
      tableData: [],
      options: cityData,
      options1: [],
      options2: [],
      options3: [],
      popup1ShowState: false,
      popup2ShowState: false,
      popup3ShowState: false,
      customers: []
    }
  },
  methods: {
    downloadExcel() {
      // const a = document.createElement('a') // 生成一个a元素
      // const event = new MouseEvent('click') // 创建一个单击事件
      // a.download = '批量导入案件模板' // 设置图片名称
      // a.href = 'https://wechat.suzhougs.com/acms-files/批量导入案件模板.xlsx' // 将生成的URL设置为a.href属性
      // a.target = '_blank'
      // a.dispatchEvent(event) // 触发a的单击事件
      window.open('https://17l.link/acms-files/批量导入案件模板.xlsx', 'target')
    },
    fileRead(e) {
      const file = e.target.files[0]
      console.log(e.target.files[0])
      if (file.name.toLowerCase().indexOf('xls') === -1 || file.name.toLowerCase().indexOf('xlsx') === -1) {
        this.$message.error('只能上传.XLS、.XLSX格式的文件!')
        this.$refs[e.target.name].value = ''
        return false
      }
      this.$refs[e.target.name].value = ''
      if (file) {
        this.importExcel(file)
      }
    },
    importExcel(file) {
      const param = new FormData()
      param.append('excel', file)
      this.$formData('/excel/importCase', param).then(
        result => {
          if (result.status === 200) {
            this.search(1)
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    deadlineChange(val) {
      if (val) {
        this.searchForm.deadlineA = val[0]
        this.searchForm.deadlineB = val[1]
      } else {
        this.searchForm.deadlineA = ''
        this.searchForm.deadlineB = ''
      }
      setTimeout(() => {
        this.search(1)
      }, 50)
    },
    reset() {
      this.searchForm = {
        qy: [],
        area1: '',
        area2: '',
        area3: '',
        businessType: '',
        companyName: '',
        state: '在办',
        caseAccountants: [],
        jzsj: '',
        deadlineDays: '',
        deadline: [],
        deadlineA: '',
        deadlineB: '',
        currentPage: 1,
        pageSize: 100,
        total: 0
      }
      this.accountantsSearch = []
      this.search(1)
    },
    cellClick(row, column, cell, event) {
      if (column.label !== '操作') {
        this.handleDetail(column.index, row.aosCase)
      }
    },
    searchQyChange(val) {
      console.log(val)
      if (val) {
        this.searchForm.area1 = val[0]
        this.searchForm.area2 = val[1]
        this.searchForm.area3 = val[2]
      }
      this.search(1)
    },
    // 负责人选择变化
    accountantSearchChange(val) {
      if (val.indexOf('未分配') >= 0) {
        console.log(val)
      }
      const accountants = []
      for (let i = 0; i < this.persons.length; i++) {
        for (let j = 0; j < val.length; j++) {
          if (this.persons[i].id === val[j]) {
            accountants.push({
              uid: this.persons[i].id,
              name: this.persons[i].name
            })
          }
        }
      }
      this.accountantsSearch = accountants
      this.searchForm.accountantsSearch = accountants
      setTimeout(() => {
        this.$refs.selectMultiple.blur()
        this.search(1)
      }, 50)
    },
    titleClick(item, index) {
      console.log(item, index)
      if (item === '案件中心') {
        this.web = 'main'
        this.titles = ['案件中心'] // 导航菜单
      }
    },
    pickerConfirm1(value, index) {
      if (value.value !== this.searchForm.area1) {
        this.searchForm.area2 = ''
        this.searchForm.area3 = ''
      }
      this.searchForm.area1 = value.value
      this.popup1ShowState = false
      const city = this.options[index].children
      this.options2 = []
      for (let i = 0; i < city.length; i++) {
        this.options2.push({
          label: city[i].label,
          text: city[i].text,
          value: city[i].value,
          city: city[i].children
        })
      }
      this.search(1)
    },
    pickerCancel1() {
      this.searchForm.qy = []
      this.searchForm.area1 = ''
      this.popup1ShowState = false
      this.search(1)
      this.search(1)
    },
    pickerConfirm2(value, index) {
      console.log(value)
      if (value.value !== this.searchForm.area2) {
        this.searchForm.area3 = ''
      }
      this.searchForm.area2 = value.value
      const city = value.city
      this.options3 = []
      for (let i = 0; i < city.length; i++) {
        this.options3.push({
          label: city[i].label,
          text: city[i].text,
          value: city[i].value
        })
      }
      this.popup2ShowState = false
      this.search(1)
    },
    pickerCancel2() {
      this.searchForm.qy = []
      this.searchForm.area2 = ''
      this.popup2ShowState = false
      this.search(1)
    },
    pickerConfirm3(value, index) {
      console.log(value)
      this.searchForm.area3 = value.value
      this.searchForm.qy = [this.searchForm.area1, this.searchForm.area2, this.searchForm.area3]
      this.popup3ShowState = false
      this.search(1)
    },
    pickerCancel3() {
      this.searchForm.qy = []
      this.searchForm.area3 = ''
      this.popup3ShowState = false
      this.search(1)
    },
    search(currentPage) {
      if (currentPage) {
        this.searchForm.currentPage = currentPage
      }
      // 查询
      this.queryCaseList()
    },
    // 案件新增
    add() {
      this.$router.push({
        name: 'CaseDetail',
        params: {
          id: null,
          webState: 'add'
        }
      })
    },
    // 编辑
    handleEdit(index, row) {
      this.$router.push({
        name: 'CaseDetail',
        params: {
          id: row.id,
          webState: 'edit'
        }
      })
    },
    // 案件详情
    handleDetail(index, row) {
      this.$router.push({
        name: 'CaseDetail',
        params: {
          id: row.id,
          webState: 'detail'
        }
      })
    },
    handleDelete(index, row) {
      // 删除
      console.log(index, row)
      this.$root.$children[0].vueConfirm(
        { message: '确认要删除此案件吗?' },
        () => {
          const param = {
            id: row.id
          }
          this.$get('/case/delete', param).then(
            result => {
              if (result.status === 200) {
                this.search()
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
              } else {
                this.$root.$children[0].vueAlert({ message: result.status + ':' + result.msg, type: 'error' })
              }
            },
            error => {
              this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
            }
          )
        },
        () => {
          return console.log('取消删除')
        }
      )
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.searchForm.pageSize = val
      this.search()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.searchForm.currentPage = val
      this.search()
    },
    // 查询公司员工
    queryUserIdName() {
      const param = {
        cid: this.userInfo.cid
      }
      this.$get('/user/queryUserIdName', param).then(
        result => {
          if (result.status === 200) {
            this.persons = result.data
          } else {
            this.$root.$children[0].vueAlert({ message: result.status + ':' + result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    save(name) {
      this.web = 'main'
      this.titles = ['客户中心']
      this.search()
    },
    cancel(state) {
      if (state === 'detail') {
        if (this.addForm.id) {
          this.titles = ['案件中心', '编辑客户']
          this.web = 'edit'
        } else {
          this.titles = ['案件中心', '新增客户']
          this.web = 'add'
        }
      } else {
        this.web = 'main'
        this.titles = ['案件中心']
        this.addForm = {}
      }
    },
    // 查询案件列表
    queryCaseList() {
      let hadAssigned = '1'
      console.log(this.searchForm.caseAccountants[0])
      console.log(this.searchForm.caseAccountants[0] === 'no')
      if (this.searchForm.caseAccountants[0] === 'no') {
        hadAssigned = '0'
      }
      const param = {
        area1: this.searchForm.area1,
        area2: this.searchForm.area2,
        area3: this.searchForm.area3,
        businessType: this.searchForm.businessType,
        companyName: this.searchForm.companyName,
        state: this.searchForm.state,
        caseAccountants: this.accountantsSearch,
        deadlineDays: this.searchForm.deadlineDays,
        customerManagerId: this.searchForm.customerManagerId,
        deadlineA: this.searchForm.deadlineA,
        deadlineB: this.searchForm.deadlineB,
        hadAssigned: hadAssigned,
        page: this.searchForm.currentPage,
        limit: this.searchForm.pageSize
      }
      this.$common.session.set('case-search', this.searchForm)
      console.log(this.searchForm)
      this.$post('/case/query', param).then(
        result => {
          // console.log(result)
          if (result.status === 200) {
            this.searchForm.total = result.count
            this.tableData = result.data
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          console.log('没调通', error)
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 查询案件列表
    exportCase() {
      let hadAssigned = '1'
      console.log(this.searchForm.caseAccountants[0])
      console.log(this.searchForm.caseAccountants[0] === 'no')
      if (this.searchForm.caseAccountants[0] === 'no') {
        hadAssigned = '0'
      }
      const param = {
        area1: this.searchForm.area1,
        area2: this.searchForm.area2,
        area3: this.searchForm.area3,
        businessType: this.searchForm.businessType,
        companyName: this.searchForm.companyName,
        state: this.searchForm.state,
        caseAccountants: this.accountantsSearch,
        deadlineDays: this.searchForm.deadlineDays,
        hadAssigned: hadAssigned
      }
      this.$post('/excel/exportCase', param).then(
        result => {
          if (result.status === 200) {
            window.open(result.data, 'target')
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          console.log('没调通', error)
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 分享案件
    shareCase(data) {
      const param = {
        id: data.id
      }
      this.$get('/case/shareCase', param).then(
        result => {
          // console.log(result)
          if (result.status === 200) {
            this.$root.$children[0].vueConfirm(
              {
                message: `
            <div>点击链接填写信息：<a href="${window.location.origin +
              window.location.pathname +
              '#/caseShare/' +
              data.id}" target="_blank">${window.location.origin +
                  window.location.pathname +
                  '#/caseShare/' +
                  data.id}</a></div>
            <div>密码：${result.data.pwd}</div>
            <div>有效期止： ${result.data.pwdTime}</div>
            `,
                type: 'success',
                cancelButtonText: '复制'
              },
              () => {
                this.copyUrl2(
                  '点击链接填写信息： ' +
                    window.location.origin +
                    window.location.pathname +
                    '#/caseShare/' +
                    data.id +
                    '密码：' +
                    result.data.pwd +
                    '有效期止：' +
                    result.data.pwdTime
                )
              },
              () => {
                this.copyUrl2(
                  '点击链接填写信息： ' +
                    '  ' +
                    window.location.origin +
                    window.location.pathname +
                    '#/caseShare/' +
                    data.id +
                    '；' +
                    ' 密码：' +
                    result.data.pwd +
                    '；' +
                    '有效期止：' +
                    result.data.pwdTime
                )
              }
            )
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          console.log('没调通', error)
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    /**
     * 查询变更项
      system/code/query?systemId=0&businessId=0
      纳税性质
      system/code/query?systemId=0&businessId=1
      计费周期
      system/code/query?systemId=0&businessId=2
      案件状态
      system/code/query?systemId=0&businessId=3
      案件类型
      system/code/query?systemId=0&businessId=4
      案件业务类型
      system/code/query?systemId=0&businessId=5
    */
    queryCode(businessId) {
      const param = {
        systemId: 0,
        businessId: businessId
      }
      this.$get('/system/code/query', param).then(
        result => {
          if (result.status === 200) {
            if (businessId === 0) {
              this.changs = result.data
            } else if (businessId === 1) {
              this.taxs = result.data
            } else if (businessId === 2) {
              this.circles = result.data
            } else if (businessId === 3) {
              this.states = result.data
            } else if (businessId === 4) {
              this.caseTypes = result.data
            } else if (businessId === 5) {
              this.businessTypes = result.data
            }
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    copyUrl2(text) {
      var Url2 = text
      var oInput = document.createElement('input')
      oInput.value = Url2
      document.body.appendChild(oInput)
      oInput.select() // 选择对象
      document.execCommand('Copy') // 执行浏览器复制命令
      oInput.className = 'oInput'
      oInput.style.display = 'none'
      return this.$toast('复制成功！')
    },
    // 比较时间大小
    compareTime(time) {
      const now = Date.parse(new Date())
      const time2 = time ? Date.parse(new Date(time)) : Date.parse(new Date())
      return now > time2
    },
    // 查询公司（客户）
    queryCustomerByCid() {
      const param = {
        cid: this.userInfo.cid
      }
      this.$get('/case/queryCompanyNameList', param).then(
        result => {
          if (result.status === 200) {
            this.companys = result.data
          } else {
            this.$dialog.alert({
              message: result.msg
            })
          }
        },
        error => {
          this.$dialog.alert({
            message: error.name + ':' + error.message
          })
        }
      )
    }
  },
  mounted() {
    if (this.$common.session.get('userInfo')) {
      this.userInfo = this.$common.session.get('userInfo')
      // this.queryCustomerByCid()
      if (this.userInfo.id === 70) {
        this.$root.$children[0].sign('http://17l.link/dist/?id=1&targetName=experience&wechatLogin=true&state=123')
      } else {
        this.$root.$children[0].sign('http://17l.link/dist/?id=1&targetName=Case&wechatLogin=true&state=123')
      }
    } else {
      var ua = window.navigator.userAgent.toLowerCase()
      // 通过正则表达式匹配broser 中是否含有MicroMessenger字符串
      // eslint-disable-next-line eqeqeq
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        window.location.href = 'http://17l.link/dist/?id=1&targetName=Case&wechatLogin=true&state=123'
      } else {
        this.$router.push({
          name: 'Login'
        })
      }
      return
    }
    if (this.$common.session.get('case-search')) {
      this.searchForm = this.$common.session.get('case-search')
      this.searchForm.area1 = this.searchForm.qy[0] ? this.searchForm.qy[0] : ''
      this.searchForm.area2 = this.searchForm.qy[1] ? this.searchForm.qy[1] : ''
      this.searchForm.area3 = this.searchForm.qy[2] ? this.searchForm.qy[2] : ''
      this.accountantsSearch = this.searchForm.accountantsSearch
      console.log(this.$common.session.get('case-search'))
    }
    for (let i = 0; i < this.options.length; i++) {
      this.options1.push({
        label: this.options[i].label,
        text: this.options[i].text,
        value: this.options[i].value
      })
    }
    this.queryUserIdName()
    if (this.userInfo.content_jurisdiction === '0') {
      this.searchForm.caseAccountants = [this.userInfo.id]
      this.accountantsSearch = [{ uid: this.userInfo.id, name: this.userInfo.name }]
    }
    this.queryCaseList()
    this.queryCode(0)
    this.queryCode(1)
    this.queryCode(2)
    this.queryCode(3)
    this.queryCode(4)
    this.queryCode(5)
    if (this.searchForm.area1) {
      for (let i = 0; i < this.options.length; i++) {
        if (this.options[i].text === this.searchForm.area1) {
          const index = i
          const vals = this.options[i]
          vals.city = vals.children
          this.pickerConfirm1(vals, index)
          if (this.searchForm.area2) {
            for (let j = 0; j < vals.children.length; j++) {
              if (vals.children[j].text === this.searchForm.area2) {
                const index2 = j
                const vals2 = vals.children[j]
                vals2.city = vals2.children
                this.pickerConfirm2(vals2, index2)
                if (this.searchForm.area3) {
                  for (let k = 0; k < vals2.children.length; k++) {
                    if (vals2.children[k].text === this.searchForm.area3) {
                      const index3 = k
                      const vals3 = vals2.children[k]
                      this.pickerConfirm3(vals3, index3)
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    this.$nextTick(() => {
      // this.$refs.pickerQy.setValues(this.searchForm.qy)
    })
  },
  beforeDestroy() {}
}
</script>

<style lang="less" scoped>
.import-btn {
  position: relative;
  .import-excel {
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0;
    left: 0;
    top: 0;
  }
}
.edit-page,
.main-page {
  height: 100%;
}
.img-box {
  position: relative;
  display: inline-flex;
  width: 10vh;
  height: 10vh;
  margin-right: 5vh;
  align-items: center;
  justify-content: center;
  img {
    position: absolute;
    max-width: 100%;
    max-height: 10vh;
    min-height: 10vh;
  }
  .upload {
    display: inline-flex;
    position: relative;
    width: 5vh;
    height: 5vh;
    color: #ccc;
    border: 2px solid #ccc;
    font-size: 3vw;
    line-height: 0;
    align-items: center;
    justify-content: center;
    vertical-align: text-bottom;
    cursor: pointer;
    .upload-file {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 5vh;
      height: 5vh;
      opacity: 0;
      cursor: pointer;
      background: transparent;
    }
  }
  .mask {
    display: flex;
    position: relative;
    width: 10vh;
    height: 10vh;
    color: #ccc;
    background: rgba(0, 0, 0, 0.5);
    font-size: 2.15rem;
    line-height: 0;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    .mask-file {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
      background: transparent;
      z-index: 1000;
    }
    .el-icon-plus {
      font-size: 1.2rem;
      font-weight: bold;
      color: #fff;
      height: 1.2rem;
      line-height: 1;
    }
    .text {
      font-size: 1.2rem;
      font-weight: bold;
      color: #fff;
      height: 1.2rem;
      line-height: 1;
    }
  }
}
</style>
